import { Directive, Input, ElementRef } from '@angular/core';
import { UserDataService } from '../services/user-data.service';
import { User } from '../models/User';

@Directive({
	selector: '[hideCongressAction]'
})
export class CongressActionsDirective {
	@Input() hideCongressAction: boolean;

	private El: ElementRef;
	public User: User = null;

	constructor(
		private el: ElementRef,
		private userDataService: UserDataService
	) {
		this.El = el;
	}

	async ngOnInit() {

		this.User = await this.userDataService.GetData().then(r => r); // DADOS DO UTILIZADOR

		if (this.User && this.User.Congress) {

			if (this.User.Congress.Active === false)
				this.El.nativeElement.remove();

		} else if (!this.User || !this.User.Congress) {
			this.El.nativeElement.remove();
		}


	}
}
